<div class="v-one-menu-dropdown">
  <button
    type="button"
    class="v-one-menu-dropdown__trigger"
    [class.v-one-menu-dropdown__trigger--disabled]="disabled"
    [class.v-one-menu-dropdown__trigger--pressed]="isPressed()"
    [attr.aria-label]="'More options'"
    [attr.aria-expanded]="isOpen()"
    [attr.aria-haspopup]="'menu'"
    (click)="toggleMenu()"
  >
    <v-one-icon
      name="dots"
      [type]="ICON_TYPE.FILLED"
      [color]="iconColor()"
      class="v-one-menu-dropdown__trigger-icon"
    />
  </button>

  @if (isOpen()) {
    <div
      class="v-one-menu-dropdown__menu"
      [class.v-one-menu-dropdown__menu--left]="menuPosition === 'left'"
      [class.v-one-menu-dropdown__menu--right]="menuPosition === 'right'"
      [@menuAnimation]
      role="menu"
      tabindex="-1"
      (keydown)="onMenuKeydown($event)"
    >
      @for (option of options; track option.value) {
        <button
          type="button"
          class="v-one-menu-dropdown__option"
          [class.v-one-menu-dropdown__option--disabled]="option.disabled"
          [attr.aria-label]="option.label"
          [disabled]="option.disabled"
          role="menuitem"
          (click)="selectOption(option)"
        >
          @if (option.icon) {
            <v-one-icon
              [name]="option.icon"
              class="v-one-menu-dropdown__option-icon"
            />
          }
          <span class="v-one-menu-dropdown__option-label">{{
            option.label | translate
          }}</span>
        </button>
      }
    </div>
  }
</div>
